export { default } from './assignIn.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/extend.js
// module id = 387
// module chunks = 0